import { TFunction } from 'i18next'

import { TransactionsInvoicesActionItem } from '../types/invoicesActionItem'

export enum TransactionsInvoicesActionType {
  Credit = 'credit',
  Duplicate = 'duplicate',
  RegisterPayment = 'registerPayment',
  Void = 'void',
}

interface GetInvoicesActionsProps {
  isInvoicePaid?: boolean
  t: TFunction
}

export const getInvoicesActions = ({ isInvoicePaid, t }: GetInvoicesActionsProps) => {
  const items: TransactionsInvoicesActionItem[] = [
    {
      children: t('transactions.table.static_actions.invoices.credit'),
      id: TransactionsInvoicesActionType.Credit,
      value: TransactionsInvoicesActionType.Credit,
    },
    {
      children: t('transactions.table.static_actions.invoices.duplicate'),
      id: TransactionsInvoicesActionType.Duplicate,
      value: TransactionsInvoicesActionType.Duplicate,
    },
    {
      children: t('transactions.table.static_actions.invoices.void'),
      id: TransactionsInvoicesActionType.Void,
      value: TransactionsInvoicesActionType.Void,
    },
  ]

  if (!isInvoicePaid) {
    items.unshift({
      children: t('transactions.table.static_actions.bills.registerPayment'),
      id: TransactionsInvoicesActionType.RegisterPayment,
      value: TransactionsInvoicesActionType.RegisterPayment,
    })
  }

  return items
}
